export function defaultStage() {
  return {
    name: "New Stage",
    description: "",
    color: "#6366f1",
    isReassignable: false,
    maxConcurrentAssignees: 1,
    assigneeRoles: [],
    estimatedDuration: 1,
    durationUnit: "Days",
    deadlineType: "None",
    slaWarningThreshold: 80,
    requiresApproval: false,
    approvalType: "Any Assignee",
    completionCriteria: "",
    autoAdvance: false,
    notifyOnEntry: false,
    notifyOnExit: false,
    isVisible: true,
  };
}
